// extracted by mini-css-extract-plugin
export default {"indicator":"theme_indicator__9NfmN","absolute":"theme_absolute__2uulH","slide":"theme_slide__z671Y","white":"theme_white__z9ClC"};